var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { TabContext, TabList, TabPanel } from '@mui/lab';
import { Box, Tab, Typography, useMediaQuery, useTheme } from '@mui/material';
import { useState } from 'react';
import useTranslate from '../../../localization/helpers';
import TechnicianSpecialties from './technician-specialties';
var Settings = function () {
    var theme = useTheme();
    var translate = useTranslate().translate;
    var isXs = useMediaQuery(theme.breakpoints.only('xs'));
    var _a = __read(useState('Technician Specialties'), 2), tabValue = _a[0], setTabValue = _a[1];
    var handleChange = function (_event, newValue) {
        setTabValue(newValue);
    };
    return (_jsxs(Box, { sx: {
            width: '100%',
            padding: isXs ? '16px' : '8px',
            display: 'flex',
            flexDirection: 'column',
            position: 'relative'
        }, children: [_jsx(Box, { display: 'flex', flexDirection: 'row', justifyContent: 'space-between', children: _jsx(Typography, { variant: isXs ? 'h4' : 'h3', color: '#009983', children: translate('settings.appSettings') }) }), _jsx(Box, { sx: { width: '100%' }, children: _jsxs(TabContext, { value: tabValue, children: [_jsx(Box, { sx: {
                                display: 'flex',
                                justifyContent: 'flex-start'
                            }, children: _jsx(TabList, { onChange: handleChange, "aria-label": 'Settings tabs', children: _jsx(Tab, { label: translate('common.technicianSpecialties'), value: 'Technician Specialties', sx: {
                                        borderRadius: '16px',
                                        color: tabValue === 'Technician Specialties'
                                            ? '#161C24 !important'
                                            : '#454F5B !important'
                                    } }) }) }), _jsx(Box, { sx: { width: '100%' }, children: _jsx(TabPanel, { value: 'Technician Specialties', sx: { padding: '6px' }, children: _jsx(TechnicianSpecialties, {}) }) })] }) })] }));
};
export default Settings;
